/**
 * The surface of every field of the plan editor: white, on the translucent cards of the plan, rather
 * than the library's grey default. Declared once so the whole editor changes, or goes back, together.
 */
export const PLAN_FIELD_VARIANT = 'white';
